import axios from "axios";
import {useHistory} from "react-router-dom";

//axios.defaults.baseURL="http://toolsdev.pfscm.org"
axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 403) {
        window.location = '/api/oauth2/authorization/azure';
      }else
      if (error.response == null || error.response.status === 401 || error.response.status === 302) {
        if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) {  const history = useHistory();
            history.push("/sign-in");
        } else {
             window.location = '/api/oauth2/authorization/azure';
        }
    }
    throw error;
});


export const AxiosClient = axios;

export const genericServiceImpl = (entity, service) => {
    return {
        getAll: () => {
            return axios.get('/api/' + service + '/' + entity);
        },
        getById: (id) => {
            return axios.get('/api/' + service + '/' + entity + '/' + id);
        },
        update: (data) => {
            return axios.put('/api/' + service + '/' + entity + '/' + data.id, data);
        },
        updateList: (id, data) => {
            return axios.put('/api/' + service + '/' + entity + '/' + id, data);
        },
        create: (data) => {
            return axios.post('/api/' + service + '/' + entity, data);
        },
        detailGet: (id) => {
            return axios.get('/api/' + service + '/' + entity + '/detail/' + id);
        },
        detailUpdate: (data) => {
            return axios.put('/api/' + service + '/' + entity + '/detail/' + data.id, data);
        },
        delete: (id) => {
            return axios.delete('/api/' + service + '/' + entity + '/' + id);
        },
        deleteStatement: (id) => {
            return axios.delete('/api/' + service + '/' + entity + '/' + id);
        }
    };
};

const genericServiceSi = (entity) => {
    return genericServiceImpl(entity, 'si');
};

export const CommodityTypeService = genericServiceSi('commodity-types');

export const UserService = genericServiceImpl('users', 'security');

export const UserRoleService = genericServiceImpl('user-roles', 'security');

export const CountryService = genericServiceSi('countries');

export const ShipToService = genericServiceImpl('ship-to-mappings', 'wambo');

export const InvoiceTrackerService = genericServiceImpl('invoice-trackers', 'onecp');

export const ProjectCodeService = genericServiceImpl('project-codes', 'onecp');

export const BillingCategory = genericServiceImpl('billing-categories', 'onecp');

//export const InvoiceOutBoundService = genericServiceImpl('invoice-lines', 'onecp')

export const StatementDeleteService = genericServiceSi('statements');

export const InvoiceOutBoundService = {
    getInvoiceLine: (invoice) => {
        return axios.get('/api/onecp/invoice-lines?invoice=' + invoice)
    },
    updateInvoiceLine: (invoice, data) => {
        return axios.put('/api/onecp/invoice-lines?invoice=' + invoice, data)
    }
}

export const InvoiceSendService = {
    sendInvoiceToCp: (invoice) => {
        return axios.get('/api/onecp/invoice-lines/send?invoice=' + invoice)
    }
}

export const ProjectCodeUpdateService = {
    
    updateProjectCode: (id, data) => {
        return axios.put('/api/onecp/project-codes?projectId=' + id, data)
    }
}

export const ProjectSendService = {
    sendProjectToCp: (id) => {
        return axios.get('/api/onecp/project-codes/send?projectId=' + id)
    }
}

export const PartnerSiteService = {
    ...genericServiceSi('partner-sites'),
    getByCountry: (country) => {
        return axios.get('/api/si/partner-sites?country=' + country)
    }
};

export const ShipmentModeService = genericServiceSi('shipment-modes');

export const DocumentTemplateService = genericServiceSi('document-templates');

export const DocumentService = genericServiceSi('documents');

export const IncoTermService = genericServiceSi('incoterms');

export const SectionService = {
    ...genericServiceSi('sections'),
    getNested: () => {
        return axios.get('/api/si/sections/nested')
    },
    getRoot: () => {
        return axios.get('/api/si/sections/at-root')
    }
};

export const StatementService = {
    ...genericServiceSi('statements'),
    getList: () => {
        return axios.get('/api/si/statements/list');
    },
    getForSection: (sectionId) => {
        return axios.get('/api/si/statements/section/' + sectionId);
    }, getAvailableStatementsFor: (sectionId, statementId) => {

        if (statementId === undefined) {
            return axios.get('/api/si/statements/available-for/' + sectionId);
        }
        return axios.get('/api/si/statements/available-for/' + sectionId + '/' + statementId);
    }
};

// export const StatementSetService = genericServiceSi('statement-sets');

export const ConsigneeService = {
    ...genericServiceSi('consignees'),
    getByCountry: (country) => {
        return axios.get('/api/si/consignees?country=' + country);
    }
};

export const ShippingInstructionService = {
    ...genericServiceSi('shipping-instructions'),
    getOutput: (id) => {
        return axios.get('/api/si/getOutput/' + id);
    },
    duplicate: (id) => {
        return axios.put('/api/si/shipping-instructions/clone/' + id);
    },
    search: (p) => {
        const params = {...{searchTerm: '', pageSize: '', pageNumber: ''}, ...p};
        return axios.get('/api/si/shipping-instructions/results?searchTerm=' + params.searchTerm + '&pageSize='
            + params.pageSize + '&offset=' + params.pageNumber)
    },
    searchPO: (orderNumber) => {
        return axios.get('/api/si/shipping-instructions/filter-for-order/' + orderNumber)
    }
};

export const UserLoginService = {
    getCurrentUser: () => {
        return axios.get('/api/security/current-user', { withCredentials: true });       
          }
    }


export const SessionService = {
    getCookie: () => {
        return axios.get('/api/session-cookie', {withCredentials : true});
    }
}

